<template>
	<div class="invoce-bg">
		<div class="bgImgHeader">
			<header class="lmy-header lmy-header-w">
				<!-- <i class="iconfont icon-back" v-if="$route.query.from=='myOrder'" @click="routetokPage('/myOrder')"></i>
				<i class="iconfont icon-back" v-else @click="routetokPage('/invoiceList')"></i> -->
				<i class="iconfont icon-yuyin" onclick="window.history.go(-1)"></i> 
				我的发票
			</header>
			<div class="headerTxt">
				<p class="InvoiceStatus">{{datas.InvoiceStatus}}</p>
				<p class="time">{{datas.CreateDate|dateLongToYMDline}}</p>
			</div>
		</div>
		<div class="lmy-invoce-menu invListBox">
			<p class="title">增值税电子发票</p>
			<!-- <div class="hotle-invoce">
				<div class="price"><span>￥</span>{{datas.Accounts?datas.Accounts:0}}</div>
				<div class="has">{{datas.InvoiceStatus}}</div>
			</div> -->
			<div class="invoce-list">
				<div class="lis-item">
					<div class="label">订单号: </div>
					<div class="content">{{datas.OrderOrBillNo?datas.OrderOrBillNo:'无'}}</div>
				</div>
				<div class="lis-item">
					<div class="label">发票金额: </div>
					<div class="content">{{datas.Accounts?datas.Accounts:0}}</div>
				</div>
				<div class="lis-item">
					<div class="label">抬头: </div>
					<div class="content">{{datas.InvoiceTitle?datas.InvoiceTitle:'无'}}</div>
				</div>
				<div class="lis-item">
					<div class="label" v-if="datas.InvoiceTitle==0">单位名称: </div>
					<div class="label" v-else>姓名: </div>
					<div class="content">{{datas.InvoiceName?datas.InvoiceName:'无'}}</div>
				</div>
				<div class="lis-item">
					<div class="label">发票项目: </div>
					<div class="content">{{datas.InvoiceItem?datas.InvoiceItem:'无'}}</div>
				</div>
				<div class="lis-item">
					<div class="label">发票种类: </div>
					<div class="content">{{datas.InvoiceKind?datas.InvoiceKind:'无'}}</div>
				</div>
				<div class="lis-item">
					<div class="label">结算类型: </div>
					<div class="content">{{datas.SettlementType?datas.SettlementType:'无'}}</div>
				</div>
				<div class="lis-item" v-if="datas.InvoiceTitle=='单位'">
					<div class="label">纳税人识别号: </div>
					<div class="content">{{datas.TaxpayerIdentifyNo?datas.TaxpayerIdentifyNo:'无'}}</div>
				</div>
				<div class="lis-item">
					<div class="label">邮箱地址: </div>
					<div class="content">{{datas.Email?datas.Email:'无'}}</div>
				</div>
				<div class="lis-item">
					<div class="label">发票备注: </div>
					<div class="content">{{datas.Remark?datas.Remark:'无'}}</div>
				</div>
				
			</div>
		</div>
	</div>

</template>
<script>
	export default{
		name:'user',
		data(){
			return{
				datas:{}
			}
		},
		methods:{
			initData(){
				var that=this;

                var params={
                    orderNo:this.$route.query.orderNo,
                }

                that.getRequest({
                    url: that.Api.InvoiceDatails,
                    params: params
                }).then(res => {

                    if (res&&res.IsSuccess) {
						this.datas = res.Result
                    }else{
                    	this.error({title: '提示', content: res.Msg});
					}

                });
			}
		},
		mounted(){
			this.initData()
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/invoice/details.vue